import React, { useCallback, useContext, useState } from "react";
import Drive_Filter_SecondPage_Orion from "./Drive_Filter_SecondPage_Orion";
import TopkpisSecond_Orion from "./TopkpisSecond_Orion";
import TopkpisSecondMain_Orion from "./TopkpisSecondMain_Orion";
import Header_Orion from "../LayoutMain_Orion/Header_Orion";
import RealWorldBox_Orion from "./DriveSecondPageCharts_Orion/RealWorldBox_Orion";
import NetEnergydBox_Orion from "./DriveSecondPageCharts_Orion/NetEnergydBox_Orion";
import NetEnergyBar_Orion from "./DriveSecondPageCharts_Orion/NetEnergyBar_Orion";
import Torquespeed_Orion from "./DriveSecondPageCharts_Orion/Torquespeed_Orion";
import TorqueBox_Orion from "./DriveSecondPageCharts_Orion/TorqueBox_Orion";
import AvgDDBar_Orion from "./DriveSecondPageCharts_Orion/AvgDDBar_Orion";
import ModeUtilization_Orion from "./DriveSecondPageCharts_Orion/ModeUtilization_Orion";
import moment from "moment";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";
import RealWorldBar_Orion from "./DriveSecondPageCharts_Orion/RealWorldBar_Orion";
import "./Driveanalysis_Custom_Orion.css";

function PageSecond_Orion(props) {
  const [secondPageState, setSecondPageState] = useState({
    // startDate: props.gloablfilter.startDate,
    // endDate: props.gloablfilter.endDate,
    // vin_num: props.gloablfilter.VIN_NUM.toString(),
    // soc_per: props.gloablfilter.SOC,
    // CITY: props.gloablfilter.CITY,
    // DEPO: props.gloablfilter.DEPO,
    "startDate": props.gloablfilter.startDate,
    "endDate": props.gloablfilter.endDate,
    "VIN_NUM": props.gloablfilter.VIN_NUM,
    "CITY": props.gloablfilter.CITY,
    "LOB": [],
    "PPL": [],
    "PL": [],
    "SOC": props.gloablfilter.SOC,
    // "pageSelected": 1,
    "DEPO": props.gloablfilter.DEPO,
    "AIR_VENTILATION": ""
  });
  const [chartTypeBox, setChartBoxSelected] = useState("netenergybox");
  const [chartType, setChartSelected] = useState("netenergy");
  const filterSubmited = useCallback((data) => {
    setSecondPageState(data);
  }, []);

  const changeNetBox = (selectedOption) => {
    setChartBoxSelected(selectedOption);
  };
  const changeNet = (selectedOption) => {
    setChartSelected(selectedOption);
  };

  const pageChange = useCallback((data) => {
    props.pageChange();
  }, []);
  const loggedInUser = useSelector(selectLoggedInUser);
  return (
    <>
      <Drive_Filter_SecondPage_Orion
        onsubmit={filterSubmited}
        pageChange={pageChange}
        secondPageState={secondPageState}
      />

      <div className="container-fluid busdrpg1 pb-1">
        <TopkpisSecond_Orion
          gloablfilter={secondPageState}
          apiend="orion_drive_api/topkpis"
        />
        <TopkpisSecondMain_Orion
          gloablfilter={secondPageState}
          apiend="orion_drive_api/topkpis_vehicle"
        />
        <section className="graphs busdrpg1">
          <div className="row mt-4 mb-3 equal-cols">
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="v-title chartbox chartbox_bus">
                <div className="titlebg_orion p-2">Real World Range Boxplot</div>
                <div className="chartHGT_Bus_Bus">
                  <RealWorldBox_Orion
                    gloablfilter={secondPageState}
                    apiend="orion_drive_api/realworldrangebox_vehicle"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="v-title chartbox chartbox_bus">
                <div className="titlebg_orion p-2">
                  Real World Range Distribution
                </div>
                <div className="chartHGT_Bus">
                  <RealWorldBar_Orion apiend="orion_drive_api/realworldrange_vehicle" gloablfilter={secondPageState}></RealWorldBar_Orion>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="v-title chartbox chartbox_bus">
                <div className="titlebg_orion p-2">Net Energy Boxplot</div>
                <div className="chartHGT_Bus">
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <select
                      className="form-select form-select-sm"
                      aria-label=".form-select-sm example"
                      onChange={(event) => changeNetBox(event.target.value)}
                      value={chartTypeBox}
                    >
                      <option value="netenergybox">Kwh/km</option>
                      <option value="netkwhbox">kWh</option>
                    </select>
                  </div>
                  {chartTypeBox === "netenergybox" ? (
                    <NetEnergydBox_Orion
                      gloablfilter={secondPageState}
                      apiend="orion_drive_api/energyconsuptionbox_whperkm_vehicle"
                    ></NetEnergydBox_Orion>
                  ) : (
                    <NetEnergydBox_Orion
                      gloablfilter={secondPageState}
                      apiend="orion_drive_api/energyconsuptionbox_kwh_vehicle"
                    ></NetEnergydBox_Orion>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="v-title chartbox chartbox_bus">
                <div className="titlebg_orion p-2">Net Energy Consumption</div>
                <div className="chartHGT_Bus">
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <select
                      className="form-select form-select-sm"
                      aria-label=".form-select-sm example"
                      onChange={(event) => changeNet(event.target.value)}
                      value={chartType}
                    >
                      <option value="netenergy">Kwh/km</option>
                      <option value="netkwh">kWh</option>
                    </select>
                  </div>

                  <div className="chartHGT_Bus">
                    {chartType === "netenergy" ? (
                      <NetEnergyBar_Orion
                        apiend="orion_drive_api/energyconsuptionbar_whperkm_vehicle"
                        gloablfilter={secondPageState}
                      ></NetEnergyBar_Orion>
                    ) : (
                      <NetEnergyBar_Orion
                        apiend="orion_drive_api/energyconsuptionbar_kwh_vehicle"
                        gloablfilter={secondPageState}
                      ></NetEnergyBar_Orion>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4 mb-3 equal-cols">
            {/* {loggedInUser.flagForHideShow === "ERC" && ( */}
            <div className="col-lg-3 col-md-6 col-sm-12">
              <Torquespeed_Orion
                apiend="orion_drive_api/torque_distribution"
                gloablfilter={secondPageState}
              ></Torquespeed_Orion>
            </div>
            {/* )} */}
            {/* {loggedInUser.flagForHideShow === "ERC" && ( */}
            <div className="col-lg-3 col-md-6 col-sm-12">
              <TorqueBox_Orion
                apiend="orion_drive_api/torque_distribution"
                gloablfilter={secondPageState}
              ></TorqueBox_Orion>
            </div>
            {/* )} */}

            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="v-title chartbox chartbox_bus">
                <div className="titlebg_orion drive_last">
                  SoC Discharge/Cycle Analysis
                </div>
                <div className="chartHGT_Bus">
                  <AvgDDBar_Orion
                    apiend="orion_drive_api/socdischarge_vs_range_vehicle"
                    gloablfilter={secondPageState}
                  ></AvgDDBar_Orion>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-12"            >
              <div className="v-title chartbox chartbox_bus">
                <div className="titlebg_orion drive_last">
                  Discharge Cycle vs Range
                </div>
                <div className="chartHGT_Bus">
                  <ModeUtilization_Orion
                    gloablfilter={secondPageState}
                    apiend="orion_drive_api/socdischarge_vehicle"
                  ></ModeUtilization_Orion>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
export default PageSecond_Orion;
